import React from "react";
import { SVG, IconProps } from "../SVG";

export const SpotMessage = ({ spotColor = "#C6F4EC", color = "#13126C", ...props }: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g fillRule="evenodd" clipPath="url(#message_spot_40_svg__a)" clipRule="evenodd">
            <path
                fill={spotColor}
                d="M17.798 6.933c-3.35.756-8.67 2.033-12.548 5.833-3.878 3.81-6.665 10.498-4.485 14.332 2.192 3.823 9.352 4.78 15.657 6.315 6.317 1.545 11.77 3.665 15.58 1.95 3.798-1.713 5.934-7.25 7.07-12.02 1.145-4.77 1.27-8.762.156-12.1-1.1-3.337-3.462-6.01-6.148-6.89-2.698-.868-5.732.046-8.127.813-2.394.766-3.795 1-7.155 1.767Z"
            />
            <path
                fill={color}
                d="M14.064 5.565c-6.55 0-11.865 5.355-11.865 11.93 0 4.61 2.683 8.848 6.846 10.805l.002.002.727.345v4.685a1.1 1.1 0 0 0 1.854.8l4.678-4.402.006-.005.006-.006.305-.295h9.244c6.55 0 11.865-5.355 11.865-11.93 0-6.574-5.316-11.929-11.865-11.929H14.064Zm-9.665 11.93c0-5.372 4.343-9.73 9.665-9.73h11.803c5.322 0 9.665 4.358 9.665 9.73 0 5.37-4.343 9.729-9.665 9.729H15.732l-.32.31-.619.6-2.818 2.652V27.256l-.629-.298-1.36-.646-.004-.002C6.593 24.718 4.4 21.256 4.4 17.494Zm5.759.964a2.5 2.5 0 0 0 2.325 1.539v-.013a2.491 2.491 0 0 0 .96-4.788 2.5 2.5 0 0 0-3.285 3.262Zm10.411 1.539a2.5 2.5 0 1 1 2.522-2.487 2.526 2.526 0 0 1-2.522 2.474v.013Zm5.623-2.481a2.5 2.5 0 0 0 2.513 2.481v-.013a2.496 2.496 0 0 0 2.487-2.517 2.5 2.5 0 0 0-5 .049Z"
            />
        </g>
        <defs>
            <clipPath id="message_spot_40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotMessage.displayName = "Message";
